<div [@routeAnimations]="o.isActivated ? o.activatedRoute : ''">
  <ng-container *ngIf="loadingRoute">
    <div class="absolute top-0 left-0 right-0">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </ng-container>
  <ngx-loading-bar color="#4D85FF" height='4px'></ngx-loading-bar>
  <router-outlet #o="outlet"/>

<!-- Floating Msaada AI Button -->
<div
  (click)="toggleMsaadaAI()"
  class="fixed bottom-6 right-6 z-50 flex items-center bg-[#FBD116]
         px-3 py-2 rounded-full cursor-pointer
         shadow-xl hover:shadow-2xl
         animate-border-pulse transition-all duration-300
         group">

  <!-- Icon -->
  <div
    class="flex items-center justify-center bg-white rounded-full
           h-10 w-10 shadow
           group-hover:scale-110 transition-transform duration-300">
    <img
      alt="Msaada AI"
      src="assets/images/hudumaAI.png"
      class="rounded-full h-6 w-6" />
  </div>

  <!-- Label (appears on hover) -->
  <span
    class="ml-3 text-sm font-semibold text-gray-900
           opacity-0 max-w-0 overflow-hidden
           group-hover:opacity-100 group-hover:max-w-[120px]
           transition-all duration-300 whitespace-nowrap">
    Msaada AI
  </span>
</div>

</div>

<!-- Msaada AI Iframe Panel - UPDATED -->
<div *ngIf="showMsaadaAI" 
     (click)="closeMsaadaAI()"
     class="fixed top-0 right-0 h-[100vh] w-full z-[100] bg-black/30 backdrop-blur-sm">
  <div class="relative h-full overflow-y-scroll">
    <div (click)="$event.stopPropagation()"
         class="absolute top-2 md:top-[20%] w-[95%] md:w-[500px] right-2 md:right-14 overflow-hidden bg-gray-100 rounded-xl shadow-2xl">
      <div class="px-3 pt-3 flex flex-wrap justify-between items-center pb-2 bg-white border-b">
        <span class="font-bold text-primary">{{ 'Msaada Ai' | concat | translate }}</span>
        <div (click)="closeMsaadaAI()" class="cursor-pointer hover:bg-gray-100 rounded-full p-1 transition-colors">
          <mat-icon>close</mat-icon>
        </div>
      </div>
      <iframe
        src="https://ai.all.tz:9099/chat/share?shared_id=0fb58192e0b811f08b290242c0a83006&from=agent&auth=g2MmQ4N2M4MjY3MDExZjBhOTkwMDI0Mm"
        style="width: 100%; height: 100%;" 
        title="msaada ai" 
        class="min-h-[90vh] md:min-h-[600px]" 
        frameborder="0"
      ></iframe>
    </div>
  </div>
</div>